import datos from "src/services/datos";
import esArray from "src/general_components/functionEsArray";

export const getRolesMenu = async (id_roles) => {
    const roles = new datos("roles");
    roles.addCondition('roles', 'id', 0, '>');
    roles.join("roles_menu", "id_roles", "id", " = ");
    roles.innerJoinTables('roles_perfiles', 'roles', "id_roles", "id", "=");
    // roles.innerJoinTables('menu', 'roles_menu', "id", "id_menu", "=")
    // roles_menu.innerJoinTables('roles', 'roles_menu', "id", "id_roles", "=")
    // menu.innerJoinTables("roles_perfiles", "id", "id_menu", " = ");
    // menu.innerJoinTables('roles_perfiles', 'roles', "id_roles", "id", "=")
    roles.addCondition('roles', 'id', id_roles, '=');
    const response = await roles.get();

    return esArray(response.wsResponse.roles);
};


export const getMenu = async () => {
    const menu = new datos("menu");
    menu.addCondition('menu', 'id', 0, '>');
    menu.join("modulos", "id", "id_modulos", " = ");
    menu.join("menu_funcionalidad", "id_menu", "id", " = ");
    menu.innerJoinTables('funcionalidades', 'menu_funcionalidad', "id", "id_funcionalidades", "=");

    const response = await menu.get();

    return esArray(response.wsResponse.menu);
};

export const postRolesMenu = async (data) => {
    const roles_menu = new datos("roles_menu");
    const response = await roles_menu.insert(data);

    return response;

};

export const getRolesMenuFuncionalidad = async (id_roles) => {
    const roles = new datos("rol_menu_funcionalidad");
    roles.addCondition('rol_menu_funcionalidad', 'id', 0, '>');
    roles.addCondition('rol_menu_funcionalidad', 'id_roles', id_roles, '=');
    roles.join("menu_funcionalidad", "id", "id_menu_funcionalidad", " = ");
    roles.innerJoinTables('funcionalidades', 'menu_funcionalidad', "id", "id_funcionalidades", "=");
    const response = await roles.get();

    // Incorpora funcionalidades de la tabla roles_menu_funcionalidad
    function transformarDatos(data) {
        return data.map(item => {
            const funcionalidadId = item.relations.funcionalidades.id;
            const menuId = item.relations.menu_funcionalidad.id_menu;
            return {
                ...item,
                id_funcionalidad: funcionalidadId,
                id_menu: menuId,
                relations: null
            };
        });
    }
    return transformarDatos(esArray(response.wsResponse.rol_menu_funcionalidad));
};

export const postRolMenuFuncionalidad = async (data) => {
    const rol_menu_funcionalidad = new datos("rol_menu_funcionalidad");
    const response = await rol_menu_funcionalidad.insert(data);

    return response;

};
